import api from "../../api/database"
import { router } from '../../main';
import Vue from 'vue'

function get_state(){
    var last_update_time = new Date(window.localStorage.getItem('last_update'))
    var expiry_limit_in_minutes = 10;
    var expiry_limit = expiry_limit_in_minutes * 60 * 1000;
    var current_date_stamp = new Date()
    var state = {}
    if (current_date_stamp - last_update_time >= expiry_limit){
        console.log("Comments limt expired")
        state = {
            commentsData: "",
            commentsMainCategory: "",
            commentsSubCategory: "",
            commentsYear: "",
            commentsPeriod: "",
            periodSelector: "",
            exportInProgress: false
        }
    } else {
        console.log("Populating comments menu using last used values.")
        state = {
            commentsData: "",
            commentsMainCategory: window.localStorage.getItem('comments_main_category'),
            commentsSubCategory: window.localStorage.getItem('comments_sub_category'),
            commentsYear: window.localStorage.getItem('comments_year'),
            commentsPeriod: window.localStorage.getItem('comments_period'),
            periodSelector: window.localStorage.getItem('periodSelector'),
            exportInProgress: false
        }
    }
    return state
}

// const state = {
//     commentsData: "",
//     commentsMainCategory: window.localStorage.getItem('comments_main_category'),
//     commentsSubCategory: window.localStorage.getItem('comments_sub_category'),
//     commentsYear: window.localStorage.getItem('comments_year'),
//     commentsPeriod: window.localStorage.getItem('comments_period'),
// }

const state = get_state()

const getters = {
    currentCommentsData: state => state.commentsData,
    currentCommentsMainCategory: state => state.commentsMainCategory,
    currentCommentsSubCategory: state => state.commentsSubCategory,
    currentCommentsYear: state => state.commentsYear,
    currentCommentsPeriod: state => state.commentsPeriod,
    isExportInProgress: state => state.exportInProgress,
    currentPeriodSelector: state => state.periodSelector
}

const actions = {
    async getCommentsData({commit}){
        const response = await api.getCommentaryData(state.commentsMainCategory,state.commentsSubCategory,state.commentsYear,state.commentsPeriod);
        console.log(response)
        if(response && response['data']['status'] == "success"){
            commit("setCommentsData",response['data']['data'])
        }else {
            console.log('Logging error')
            console.log(response)
            commit("setCommentsData","unable to fetch data")
        }
    },

    async initDeleteComment({commit, dispatch}, comments, metaData){
        const response = await api.deleteComments(comments, metaData);
        dispatch('resetOverlay');
        if (response && response["data"] && response["data"]["status"] === "success") {
            Vue.notify({
                group: 'success',
                text: 'Deleted the comment...',
                closeOnClick:true
              })
            await dispatch('getCommentsData');
        } else {
            Vue.notify({
                group: 'error',
                text: 'Unable to Delete the comment...',
                closeOnClick:true
              })
        }
    },

    async fetchExportFile({commit}){
        commit('tweakExportInProgress', true);
        const response = await api.getCommentaryData(state.commentsMainCategory,state.commentsSubCategory,state.commentsYear,state.commentsPeriod);
        if(response && response['data']['status'] == "success" && response['data']['data'] && response['data']['data'].length > 0){
            const items = response['data']['data'].map(item => ({
                ...item,
                latest_editor_details: item.latest_editor_email && item.latest_editor_fName && item.latest_editor_lName ?
                `${item.latest_editor_fName} ${item.latest_editor_lName} (${item.latest_editor_email})` : ''
            }));
            const replacer = (key, value) => (value === null || value === undefined) ? '' : value;
            const header = [
                {
                    label: 'Year',
                    value: state.commentsYear
                },
                {
                    label: 'Filter By',
                    value: state.commentsMainCategory
                },
                {
                    label: ((mainCategory) => {
                        if (mainCategory === 'Providers') {
                            return "Provider";
                        } else if (mainCategory === 'Verticals') {
                            return "Vertical";
                        }
                    })(state.commentsMainCategory),
                    value: state.commentsSubCategory 
                },
                {
                    label: 'Period',
                    value: state.commentsPeriod
                },
                {
                    label: 'Comment For',
                    dataKey: 'program_name',
                    value: ''
                },
                {
                    label: 'Comment By',
                    dataKey: 'userEmail',
                    value: ''
                },
                {
                    label: 'Comment Period',
                    dataKey: 'period',
                    value: ''
                },
                {
                    label: 'Comment Date',
                    dataKey: 'timeStamp', // (d) => d.split(' ').slice(0,3).join(' '),
                    valueFn: (ts) => {
                        try {
                            return ts === 'unknown' ? ts : ts.split(' ').slice(0,3).join(' ');
                        } catch (e) {
                            return "unknown"
                        }
                    }
                },
                {
                    label: 'Comment Time',
                    dataKey: 'timeStamp',
                    valueFn: (ts) => {
                        try {
                            console.log('====', ts);
                            return ts === 'unknown' ? ts : ts.split(' ')[3];
                        } catch (e) {
                            return "unknown"
                        }
                    }
                },
                {
                    label: 'Comment',
                    dataKey: 'comment',
                    value: ''
                },
                {
                    label: 'Last Updated By',
                    dataKey: 'latest_editor_details',
                    value: ''
                }

            ]; //Object.keys(items[0]);
            let headerLabels = header.map(i => {
                return i.label;
            });
            let csv = items.map(row => header.map(fieldName => {
                if (fieldName.dataKey === undefined) {
                    return JSON.stringify(fieldName.value);
                } else if (fieldName.valueFn) {
                    return JSON.stringify(fieldName.valueFn(row.timeStamp));
                } else {
                    return JSON.stringify(row[fieldName.dataKey]);
                }
            }).join(','));
            csv.unshift(headerLabels.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
            const url = window.URL.createObjectURL(new Blob([blob]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', (state.commentsYear+'-'+state.commentsSubCategory+'-comments.csv').trim().replace(/\s/g, '').toLowerCase());
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            Vue.notify({
                group: 'success',
                text: 'Download Successful.....',
                closeOnClick:true
                })
        }
        else  if(response && response['data']['status'] == "success" && response['data']['data'] && response['data']['data'].length <= 0){
            Vue.notify({
                group: 'warn',
                text: 'Data not found for the selected filter criteria',
                closeOnClick:true
              })
        }
         else {
            Vue.notify({
                group: 'error',
                text: 'Download Failed...',
                closeOnClick:true
              })
        }
    },

    updateCommentaryParams({commit},model){
        var current_date = new Date()
        console.log(`Updating commentary params. mainCategory: ${model.mainCategory}, subCategory: ${model.subCategory},
                    year: ${model.year}, period: ${model.period}`)
        commit('setCommentsMainCategory',model.mainCategory)
        commit('setCommentsSubCategory',model.subCategory)
        commit('setCommentsYear',model.year)
        commit('setCommentsPeriod',model.period)
        commit('setPeriodSelector', model.periodSelector);
        window.localStorage.setItem('comments_main_category',model.mainCategory)
        window.localStorage.setItem('comments_sub_category',model.subCategory)
       window.localStorage.setItem('comments_year',model.year)
        window.localStorage.setItem('comments_period',model.period)
        window.localStorage.setItem('last_update', String(current_date))
        window.localStorage.setItem('periodSelector', model.periodSelector)
    },
    async updateComments({commit, dispatch}, obj){
        const response = await api.updateComments(obj);
        console.log(response)
        if (response && response["data"] && response["data"]["status"] === "success") {
            router.push({name: 'commentary'});
            Vue.notify({
                group: 'success',
                text: 'Add Successful.....',
                closeOnClick:true
                })
        } else {
            Vue.notify({
                group: 'error',
                text: 'Failed to Add Comments...',
                closeOnClick:true
              })
        }        
    },
    async postEditComment({commit, dispatch}, obj){
        const response = await api.editComments(obj)
        console.log(response, '--- response from edit PUT');
        var msg = response["data"]["data"]
        if (response  && response["data"] && response["data"]["status"] === "success") {
            router.push({name: 'commentary'});
            Vue.notify({
                group: 'success',
                text: 'Edit Successful.....',
                closeOnClick:true
                })
        } else {
            Vue.notify({
                group: 'error',
                text: "Failed " + msg,
                closeOnClick:true
              })
        }
    }
}

const mutations = {
    setCommentsData: (state, newData) => {
        state.commentsData = newData
    },
    setCommentsMainCategory: (state, newData) => {
        state.commentsMainCategory = newData
    },
    setCommentsSubCategory: (state, newData) => {
        state.commentsSubCategory = newData
    },
    setCommentsYear: (state, newData) => {
        state.commentsYear = newData
    },
    setCommentsPeriod: (state, newData) => {
        state.commentsPeriod = newData
    },
    setPeriodSelector: (state, newData) => {
        state.periodSelector = newData;
    },
    tweakExportInProgress: (state, newData) => {
        state.exportInProgress = newData
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
